import { addScript } from '@funtech-int/yango-shared';

import { Logger } from '@kinopoisk-int/logger';

const BUGHUNTER_WIDGET_SRC = 'https://yastatic.net/s3/frontend/butterfly/latest/butterfly.js';

const BUGHUNTER_SCRIPT_ID = 'yndxbug';
const BUGHUNTER_CONTAINER_ID = 'bughunter-container';

const INITIAL_BUGHUNTER_CONFIG = {
    id: BUGHUNTER_SCRIPT_ID,
    'container-id': BUGHUNTER_CONTAINER_ID,
    position: 'left',
    modules: 'forms,ab,info',
    form: '10022082.8ce0d0837d54ba1bb1d1cc06e3adb8f7ed8f98e6',
    'custom-theme': '',
    'bug-color-theme': 'dark',
    screenshot: '',
    'data-domain': 'yandex',
};

type BughunterConfigExtraData = { [key: string]: string } & {
    'data-info'?: string;
    'data-data'?: string;
    'data-exp'?: string;
};

export interface BughunterExtraData {
    version?: string;
    yandexuid?: string;
    profileId?: number;
    puid?: string;
    email?: string;
    experimentIds?: string[];
    requestId?: string;
    traceId?: string;
}

function setElementAttributesById(id: string, attributes: { [key: string]: string }) {
    const element = document.getElementById(id);

    if (element) {
        Object.keys(attributes).forEach((key) => {
            const attributeValue = attributes[key];
            if (attributeValue) {
                element.setAttribute(key, attributeValue);
            }
        });
    }
}

export function initBughunter(logger: Logger) {
    const div = document.createElement('div');
    div.id = BUGHUNTER_CONTAINER_ID;
    div.setAttribute('dir', 'ltr');
    document.body.appendChild(div);
    addScript(BUGHUNTER_WIDGET_SRC, { params: INITIAL_BUGHUNTER_CONFIG }, logger);
}

interface BughunterOptions {
    logger: Logger;
}

export function updateBughunterData(data: BughunterExtraData, { logger }: BughunterOptions) {
    const config: BughunterConfigExtraData = {};

    const dataInfo = JSON.stringify(data);
    config['data-info'] = dataInfo;
    config['data-data'] = dataInfo;
    if (data.experimentIds && data.experimentIds.length > 0) {
        config['data-exp'] = `experiments: ${data.experimentIds.join(',')}`;
    }

    try {
        setElementAttributesById(BUGHUNTER_SCRIPT_ID, config);
    } catch (error) {
        if (error instanceof Error) logger.error({ error }, error.message);
    }
}
